import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const stages = [{
  stage: 'Source',
  width: '100%',
  loss: 'Deal flow arrives through email, referrals, events, portals and databases with no single record.'
}, {
  stage: 'Intake',
  width: '84%',
  loss: 'Analysts repeatedly collect and normalize the same company information.'
}, {
  stage: 'Diligence',
  width: '66%',
  loss: 'Depth and quality vary across people, funds and opportunities.'
}, {
  stage: 'Decide',
  width: '46%',
  loss: 'Rationale is buried in documents and conversations; internal alignment stretches weeks into months.'
}, {
  stage: 'Report',
  width: '28%',
  loss: 'Portfolio and LP reporting stay manual and disconnected from the deal record.'
}];
export function BrokenWorkflowSlide() {
  return <Slide index={4} data-id="element-39" data-mp="ei94h97a0x8u">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-40" data-mp="eir1w95odhic">
        <div className="max-w-[60%]" data-id="element-41" data-mp="1b5j1wh2llnvk">
          <Eyebrow data-id="element-42" data-mp="1b6kjz5i17ams">The workflow today</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-43" data-mp="1758xv9yd97jc">
            Investment teams have more data than ever — and less time to build
            conviction.
          </Title>
        </div>
        <Caption className="max-w-[28%] text-right" data-id="element-44" data-mp="1g5dv4r9uipjs">
          Information is lost at every stage, and the institutional knowledge
          created never comes back.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-5 gap-[1.6vw]" data-id="element-45" data-mp="1pv773tdwh6ok">
        {stages.map((s, i) => <Reveal key={s.stage} delay={0.07 * i} className="flex flex-col" data-id="element-46" data-mp="1pxjjlr0w2ou8" data-mpi={i}>
            <div className="h-[1.2vh] w-full bg-white/[0.06]" data-id="element-47" data-mp="23u6ukxpoffj5">
              <div className="h-full" style={{
            width: s.width,
            background: `rgba(59,140,255,${0.85 - i * 0.13})`
          }} data-id="element-48" data-mp="1ywybmuwpf7gu" />
            </div>
            <p className="mt-[1.8vh] text-[clamp(12px,1.35vw,28px)] text-[#F4F7FC]" data-id="element-49" data-mp="4jowamhh8rqo">
              {s.stage}
            </p>
            <div className="mt-[1.6vh] border-l border-dashed border-[#D8A55A]/40 pl-[0.9vw]" data-id="element-50" data-mp="29j6sqmwlfkgo">
              <span className="text-[clamp(7px,0.72vw,15px)] uppercase tracking-[0.2em] text-[#D8A55A]" data-id="element-51" data-mp="29l1chxw4p6j6">
                Knowledge lost
              </span>
              <Caption className="mt-[0.9vh]" data-id="element-52" data-mp="2iko5bvasl40m">{s.loss}</Caption>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.42} className="mt-[3.4vh] flex items-center justify-between border-t border-white/12 pt-[2vh]" data-id="element-53" data-mp="2niprip3iljgb">
        <p className="text-[clamp(11px,1.2vw,25px)] text-[#C3CBD9]" data-id="element-54" data-mp="2x898tqbkx592">
          Passed opportunities and unsuccessful investments rarely become
          reusable intelligence.
        </p>
        <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.24em] text-[#3B8CFF]" data-id="element-55" data-mp="369qx3vz54d8u">
          The record resets on every deal
        </span>
      </Reveal>
    </Slide>;
}